export default {
    api1: process.env.NODE_ENV == 'development' ? '/api1' : process.env.VUE_APP_API1,
    api2: process.env.NODE_ENV == 'development' ? '/api2/service' : process.env.VUE_APP_API2,
    api4: process.env.NODE_ENV == 'development' ? '/api4' : process.env.VUE_APP_API4,
    // 无水印上传
    uploadURL: `${process.env.NODE_ENV == 'development' ? '/api1' : process.env.VUE_APP_API1}/api/Upload/UploadNoWatermarkImg`,
    // 带水印上传
    uploadURLImg: `${process.env.NODE_ENV == 'development' ? '/api1' : process.env.VUE_APP_API1}/api/Upload/UploadImg`,
    // mapURL: 'http://www.gongkongbpo.qa/bpojob/baiduMap.html'
    mapURL: `${process.env.NODE_ENV == 'development' ? 'http://www.qa.gongkongbpo.com' : process.env.VUE_APP_API3}/bpojob/baiduMap.html`
}
